module.exports = "/static/assets/8a56a3bbb96757eedd16ec77f7870130.png";